module.exports = __webpack_public_path__ + "img/sale.7db9f44.png";